import React, { useEffect } from "react";
// import { useNavigate } from "react-router";
import { Modal, Row, Col, Form, Button, Input, message } from "antd";
import { camelCase } from "../../../utils";
import urls from "../../../api/urls";
import NormalAPI from "../../../api";
const { POST_LCR } = urls;
import cross_button from "../../../assests/images/CrossButton.svg";
import "./style.scss";
const GenerateLcrModal = ({
  isModalOpen,
  setIsModalOpen,
  lcrPayLoad,
  lcrNumber,
  handleCallBack = () => {},
  flightNum,
  coLoader,
}) => {
  const user_premiseId = JSON.parse(window?.localStorage?.getItem("userId"));
  const [form] = Form.useForm();
  const currentDate = new Date();
  let year = currentDate.getFullYear();
  let month = currentDate.getMonth() + 1;
  let day = currentDate.getDate();
  useEffect(() => {
    console.log(lcrPayLoad, "lcrPayLoad");
    if (lcrPayLoad) form.setFieldValue("toHub", camelCase(lcrPayLoad?.toHub));
  }, [lcrPayLoad]);

  const handleSave = async () => {
    setIsModalOpen(false);
    let temp = { ...lcrPayLoad, toDate: `${day}/${month}/${year}` };
    form.resetFields();
    let responseEligibleBag = await NormalAPI.Api(POST_LCR).postCustomHeader(
      temp,
      {
        "SMCS-PREMISE-ID": user_premiseId?.userInfo?.premiseId,
        "USER-ID": user_premiseId?.userInfo?.userId,
      }
    );
    console.log(responseEligibleBag);
    if (responseEligibleBag?.status) {
      lcrNumber(responseEligibleBag);
      message.success("LCR generated");
      handleCallBack(lcrPayLoad);
    } else if (!responseEligibleBag?.status) {
      message.error(responseEligibleBag?.response?.data?.message || "Network error");
      // handleCallBack(lcrPayLoad);
    }
    
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <Modal
      className="lcr-modal-wrapper"
      title="Generate LCR"
      open={isModalOpen}
      closeIcon={<img src={cross_button} />}
      onCancel={handleCancel}
      footer={null}
      style={{ padding: "0" }}
    >
      <Form
        layout={"vertical"}
        form={form}
        autoComplete="off"
        onFinish={handleSave}
      >
        <Row gutter={12} className="mb-3">
          <Col span={12}>
            <Form.Item label="Hub User" name="hubUser">
              <Input defaultValue={camelCase(lcrPayLoad?.hubUser)} disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="To Date" name="toDate">
              <Input defaultValue={`${day}/${month}/${year}`} disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="From Hub" name="fromHub">
              <Input defaultValue={camelCase(lcrPayLoad?.fromHub)} disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="To Hub" name="toHub">
              <Input defaultValue={camelCase(lcrPayLoad?.toHub)} disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Travel By" name="travelBy">
              <Input defaultValue={camelCase(lcrPayLoad?.travelBy)} disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Ownership" name="coLoader">
              <Input defaultValue={camelCase(lcrPayLoad?.coloader)} disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={!flightNum ? "Vehicle number" : "Flight Number"}
              name="vehicleNum"
            >
              <Input defaultValue={lcrPayLoad?.vehicleNum} disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={!coLoader ? "Driver name" : "Co-loader"}
              name="driverName"
            >
              <Input
                defaultValue={camelCase(lcrPayLoad?.driverName)}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
        <hr className="divider" />
        <div className="d-flex flex-end p-1 footer-btn">
          <Button htmlType="submit" className="btn-style save-btn btn-two">
            SUBMIT
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default GenerateLcrModal;
